angular.module('main').directive('btnEdit', () => ({
	restrict: 'AE',
	scope: {
		text: '@snText',
		snEmpty: '@',
		isLink: '@',
		linkHref: '@'
	},
	template(el, attr) {
		let template = '';

		if (attr.isLink === 'true' && attr.linkHref) {
			template = `<a ng-href="{{linkHref}}" class="btn btn-default">
                                <i class="fi fi-edit pr-0" ng-if="snEmpty"></i>
                                <i class="fi fi-edit" ng-if="!snEmpty"></i>
                                 {{text}}
                            </a>`;
		} else {
			template = `<button class="btn btn-default">
                            <i class="fi fi-edit pr-0" ng-if="snEmpty"></i>
                            <i class="fi fi-edit" ng-if="!snEmpty"></i>
                             {{text}}
                        </button>`;
		}

		return template;
	},
	replace: true,
	transclude: true,
	link(scope) {
		scope.text = scope.text || 'Edit';
		if (scope.snEmpty) {
			scope.text = '';
		}
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnEdit.js